import { LocalMessageAttachment } from "@knowt/syncing/types/common";

export const AI_HOMEWORK_SOLVER_LS_KEY = "ai-homework-solver";
export type AIHomeworkSolverLS = {
    message: string;
    attachments: LocalMessageAttachment[];
};
